/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type USER_STATUS = "ACTIVE" | "BANNED" | "PREMOD" | "SUSPENDED" | "WARNED" | "%future added value";
export type UnansweredCommentsTabContainer_viewer = {
    readonly status: {
        readonly current: ReadonlyArray<USER_STATUS>;
    };
    readonly " $fragmentRefs": FragmentRefs<"UnansweredCommentsTabCommentContainer_viewer" | "CreateCommentReplyMutation_viewer" | "CreateCommentMutation_viewer">;
    readonly " $refType": "UnansweredCommentsTabContainer_viewer";
};
export type UnansweredCommentsTabContainer_viewer$data = UnansweredCommentsTabContainer_viewer;
export type UnansweredCommentsTabContainer_viewer$key = {
    readonly " $data"?: UnansweredCommentsTabContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"UnansweredCommentsTabContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UnansweredCommentsTabContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "UserStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "current",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UnansweredCommentsTabCommentContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CreateCommentReplyMutation_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CreateCommentMutation_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = 'dcbbed84489fff1c50588d3bad40e9a7';
export default node;
